<template>
    <!--修改时间:23.7.1-->
    <!--
      <MyCeiling :ceilingTop="110">
        <template>
          内容
        </template>
      </MyCeiling>
    -->
    <div :style="stickyChange" class="MyCeiling">
      <slot></slot>
    </div>
  </template>
   
  <script>
  export default {
    name: 'Ceiling',
    props: {
      ceilingTop: {
        type: Number,
        default: 400
      }
    },
    data() {
      return {
        // 吸顶样式
        stickyChange: 'position:relative;z-index:0'
      }
    },
    methods: {
      // 吸顶方法
      getScroll(e) {
        let topDis = window.pageYOffset || document.documentElement.scrollTop ||
          document.body.scrollTop || e.target.scrollTop
        //此处660为测试组件滑动到顶部的距离；
        if (topDis >= this.ceilingTop) {
          this.stickyChange = 'position:fixed;top:0px;opacity: 0.98;z-index:999'
        } else {
          this.stickyChange = 'position:relative;z-index:0'
        }
        //console.log('吸顶监听...')
      }
    },
    mounted() {
      window.addEventListener('scroll', this.getScroll, true)
    },
    destroyed() {
      window.removeEventListener('scroll', this.getScroll, true)
    }
  }
  </script>
   
  <style scoped>
  .MyCeiling::before {
    clear: both;
    content: '';
    display: block;
  }
  </style>